import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';

import { TaxpayerProfileJson } from './microservices/json/TaxpayerProfile.json';
import { MicroResponse } from './microservices/response/micro.response';
import { TaxpayerIdActivityResponse } from './microservices/response/taxpayerIdActivity.response';

@Injectable({ providedIn: 'root' })
export class TaxpayerService {
  private endpoint = `${environment.IDEMPIER_GATEWAY}/v1/taxpayer`;
  private http = inject(HttpClient);

  get(): Observable<MicroResponse<TaxpayerProfileJson>> {
    return this.http.get<MicroResponse<TaxpayerProfileJson>>(this.endpoint);
  }

  getBySignatureId(
    signatureId: number,
  ): Observable<MicroResponse<TaxpayerProfileJson>> {
    return this.http.get<MicroResponse<TaxpayerProfileJson>>(
      `${this.endpoint}?signatureId=${signatureId}`,
    );
  }

  getIdActivity(
    signatureId: number,
  ): Observable<MicroResponse<TaxpayerIdActivityResponse>> {
    return this.http.get<MicroResponse<TaxpayerIdActivityResponse>>(
      this.endpoint +
        `/projection?fields=taxpayerId,activity&signatureId=${signatureId}`,
    );
  }

  save(params: TaxpayerProfileJson): Observable<MicroResponse<any>> {
    return this.http.post<MicroResponse<any>>(this.endpoint, params);
  }

  update(params: TaxpayerProfileJson): Observable<MicroResponse<any>> {
    return this.http.put<MicroResponse<any>>(this.endpoint, params);
  }
}
